























































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import $ from "jquery";
// import * as qiniu from 'qiniu-js';
import { subTransfer } from "@/api/user/user";
import { SERVER_HOST } from "@/global/constants";
import { uploadOss } from "@/global/utils";

@Component
export default class Supply extends Vue {
  private keyword: string = process.env.VUE_APP_KEYWORD;
  private formData: object = {
    withdraw_amount: "", // 提现金额
    invoice_amount: "", // 邮寄发票总金额
    confirmation_account: "", //对账函
    invoice_file_img: "", // 发票
    express_name: "", // 快递名称
    express_num: "", // 快递单号
  };
  private ruleValidate: object = {
    withdraw_amount: [
      {
        required: true,
        message: "提现金额为空",
        trigger: "blur",
      },
      {
        min: 4,
        message: "金额不能小于1000",
        trigger: "blur",
      },
    ],
    invoice_amount: [
      { required: true, message: "邮寄发票总金额", trigger: "blur" },
    ],
    confirmation_account: [
      { required: false, message: "请上传对账函", trigger: "blur" },
    ],
    invoice_file_img: [
      { required: false, message: "请上传发票", trigger: "blur" },
    ],
    express_name: [{ required: true, message: "快递名称", trigger: "blur" }],
    express_num: [{ required: true, message: "快递单号", trigger: "blur" }],
  };
  // 展示图片modal
  private imgVisible: boolean = false;
  // 展示图片Url
  private curImgUrl: string = "";
  // 正在上传图片个数
  private isUploading: number = 0;
  // 上传图片
  private async upLoad(e, currUrl) {
    let file = e.target.files[0];
    if (!file) return;
    let sid = 1;
    let times = new Date().getTime();
    let extension = file.name.split(".")[1];
    let key = `${sid}/${times}.${extension}`;
    this.isUploading = this.isUploading + 1;
    uploadOss(file, key)
      .then((res) => {
        this.isUploading = this.isUploading - 1;
        this.formData[currUrl] = res;
      })
      .catch((err) => {
        console.log(err);
        alert("上传失败");
      });
  }

  // private upLoad(e, currUrl) {
  //   const token = '/v1/sdk/qiniu/token.json';
  //   let sid = 1;
  //   let times = new Date().getTime();
  //   let file = e.target.files[0];
  //   if (!file) return;
  //   let extension = file.name.split('.')[1];
  //   let key = `${sid}/${times}.${extension}`;

  //   $.ajax({
  //     type: 'GET',
  //     url: SERVER_HOST + token,
  //     xhrFields: {
  //       withCredentials: true,
  //     },
  //     error: err => {
  //       console.log(err);
  //     },
  //     success: data => {
  //       const config = {
  //         useCdnDomain: true,
  //         region: null,
  //       };
  //       const putExtra = {
  //         fname: '',
  //         params: {},
  //         mimeType: null,
  //         domain: 'https://static.cdn.longmaosoft.com',
  //       };
  //       this.isUploading = this.isUploading + 1;
  //       const observer = {
  //         next: res => {},
  //         error(err) {
  //           alert('上传失败');
  //         },
  //         complete: res => {
  //           this.isUploading = this.isUploading - 1;
  //           this.formData[
  //             currUrl
  //           ] = `https://static.cdn.longmaosoft.com/${res.key}`;
  //         },
  //       };
  //       const observable = qiniu.upload(
  //         file,
  //         key,
  //         data.result,
  //         putExtra,
  //         config
  //       );
  //       const subscription = observable.subscribe(observer);
  //     },
  //   });
  // }
  // 填写金额
  private handleAmountChange() {
    (this.formData as any).invoice_amount = (
      this.formData as any
    ).withdraw_amount;
  }
  // 查看图片
  private showThisImg(e, url) {
    console.log("show");
    this.curImgUrl = url;
    this.imgVisible = true;
  }
  // 提交供应商数据
  private handleValidate() {
    (this.$refs.formValidate as any).validate((valid) => {
      if (valid) {
        // 验证通过
        this.handleSubmit();
      } else {
        this.$Notice.error({ title: "提示", desc: "请正确填写数据!" });
      }
    });
  }
  // 提交供应商数据
  private async handleSubmit() {
    const letterLogo =
      "https://rwlm.cdn.sdshua.com/task.totoro.cdn.shandianshua.com/letter_logo.png";
    const invoiceLogo =
      "https://rwlm.cdn.sdshua.com/task.totoro.cdn.shandianshua.com/invoice_logo.png";
    let reqData: any = this.formData;
    reqData.withdraw_amount = Math.round(reqData.withdraw_amount * 100);
    reqData.invoice_amount = reqData.withdraw_amount;
    reqData.confirmation_account =
      reqData.confirmation_account == ""
        ? letterLogo
        : reqData.confirmation_account;
    reqData.invoice_file_img =
      reqData.invoice_file_img == "" ? invoiceLogo : reqData.invoice_file_img;
    debugger;
    const res: any = await subTransfer(reqData);
    if (res.code == 200) {
      this.$Modal.success({
        title: "提交成功！",
        content:
          "<div><p>每月14日之前收到发票，次月15日结算，14日之后收到发票下下月15日结算</p><p>转账情况可在【结算中】下【查看明细】中查询</p></div>",
      });
    } else {
      this.$Modal.error({
        title: "提交失败！",
        content: res.message,
      });
    }
  }
}
